<div *ngIf="quoteData">

    <!-- ══ Agricultural Vehicles ══ -->
    <mat-accordion multi *ngIf="quoteData.agricultural_vehicles && quoteData.agricultural_vehicles.length > 0">
        <div class="form_sections" *ngFor="let v of quoteData.agricultural_vehicles; let i = index">
            <mat-expansion-panel [expanded]="i == 0">
                <mat-expansion-panel-header>
                    <mat-panel-title><h4><u>Agricultural Vehicle {{ i + 1 }}: {{ v.make }} {{ v.model }}</u></h4></mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-10">
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registration Number:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.registration_number || 'N/A'" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>VIN:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.vin" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Make:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.make" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Model:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.model" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Year:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.year" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Body Type:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.body_type" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Value:</label></div>
                            <div class="col-md-8">
                                <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text dark-green-bg text-white">&pound;</span></div>
                                    <input type="text" [value]="v.value" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Cover Type:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.cover_type" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3" *ngIf="v.extended_use">
                            <div class="col-md-4 text-white"><label>Extended Use:</label></div>
                            <div class="col-md-8">
                                <mat-checkbox [checked]="v.extended_use.driver_business_use" disabled class="mr-3">Driver Business Use</mat-checkbox>
                                <mat-checkbox [checked]="v.extended_use.livestock_carriage" disabled>Livestock Carriage</mat-checkbox>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Green Card:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.green_card == 'Yes'">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.green_card != 'Yes'">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registered Owner:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.is_registered_owner == 'Yes' || !v.owner_name">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.is_registered_owner == 'No' || v.owner_name">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3" *ngIf="v.owner_name">
                            <div class="col-md-4 text-white"><label>Owner Name:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.owner_name" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3" *ngIf="v.postcode">
                            <div class="col-md-4 text-white"><label>Overnight Postcode(s):</label></div>
                            <div class="col-md-8"><input type="text" [value]="overnightPostcodes(v)" class="form-control form-control-sm" readonly></div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-accordion>

    <!-- ══ Cars ══ -->
    <mat-accordion multi *ngIf="quoteData.cars && quoteData.cars.length > 0">
        <div class="form_sections" *ngFor="let v of quoteData.cars; let i = index">
            <mat-expansion-panel [expanded]="i == 0">
                <mat-expansion-panel-header>
                    <mat-panel-title><h4><u>Car {{ i + 1 }}: {{ v.make }} {{ v.model }}</u></h4></mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-10">
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registration Number:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.registration_number" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Make:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.make" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Model:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.model" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Year:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.year" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Value:</label></div>
                            <div class="col-md-8">
                                <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text dark-green-bg text-white">&pound;</span></div>
                                    <input type="text" [value]="v.value" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Cover Type:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.cover_type" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Driving Restriction:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.driving_restriction" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>NCD Years:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.ncd" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Annual Mileage:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.annual_mileage || v.mileage" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Green Card:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.green_card == 'Yes'">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.green_card != 'Yes'">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registered Owner:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.is_registered_owner == 'Yes' || !v.owner_name">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.is_registered_owner == 'No' || v.owner_name">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3" *ngIf="v.postcode">
                            <div class="col-md-4 text-white"><label>Overnight Postcode(s):</label></div>
                            <div class="col-md-8"><input type="text" [value]="overnightPostcodes(v)" class="form-control form-control-sm" readonly></div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-accordion>

    <!-- ══ Commercial Vehicles ══ -->
    <mat-accordion multi *ngIf="quoteData.commercial_vehicles && quoteData.commercial_vehicles.length > 0">
        <div class="form_sections" *ngFor="let v of quoteData.commercial_vehicles; let i = index">
            <mat-expansion-panel [expanded]="i == 0">
                <mat-expansion-panel-header>
                    <mat-panel-title><h4><u>Commercial Vehicle {{ i + 1 }}: {{ v.make }} {{ v.model }}</u></h4></mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-10">
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registration Number:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.registration_number" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Make:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.make" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Model:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.model" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Year:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.year" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Gross Vehicle Weight:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.weight" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Value:</label></div>
                            <div class="col-md-8">
                                <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text dark-green-bg text-white">&pound;</span></div>
                                    <input type="text" [value]="v.value" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Cover Type:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.cover_type" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Annual Mileage:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.annual_mileage || v.mileage" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registered Owner:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.is_registered_owner == 'Yes' || !v.owner_name">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.is_registered_owner == 'No' || v.owner_name">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3" *ngIf="v.postcode">
                            <div class="col-md-4 text-white"><label>Overnight Postcode(s):</label></div>
                            <div class="col-md-8"><input type="text" [value]="overnightPostcodes(v)" class="form-control form-control-sm" readonly></div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-accordion>

    <!-- ══ Horseboxes ══ -->
    <mat-accordion multi *ngIf="quoteData.horseboxes && quoteData.horseboxes.length > 0">
        <div class="form_sections" *ngFor="let v of quoteData.horseboxes; let i = index">
            <mat-expansion-panel [expanded]="i == 0">
                <mat-expansion-panel-header>
                    <mat-panel-title><h4><u>Horsebox {{ i + 1 }}: {{ v.make }} {{ v.model }}</u></h4></mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-10">
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registration Number:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.registration_number" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Make:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.make" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Model:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.model" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Year:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.year" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Gross Vehicle Weight:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.weight" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Value:</label></div>
                            <div class="col-md-8">
                                <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text dark-green-bg text-white">&pound;</span></div>
                                    <input type="text" [value]="v.value" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Cover Type:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.cover_type" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Driving Restriction:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.driving_restriction" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>NCD Years:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.ncd" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Annual Mileage:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.mileage" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3" *ngIf="v.extended_use">
                            <div class="col-md-4 text-white"><label>Extended Use:</label></div>
                            <div class="col-md-8">
                                <mat-checkbox [checked]="v.extended_use.personal_business_use" disabled class="mr-3">Personal Business Use</mat-checkbox>
                                <mat-checkbox [checked]="v.extended_use.driver_business_use" disabled class="mr-3">Driver Business Use</mat-checkbox>
                                <mat-checkbox [checked]="v.extended_use.livestock_carriage" disabled>Livestock Carriage</mat-checkbox>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Green Card:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.green_card == 'Yes'">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.green_card != 'Yes'">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registered Owner:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.is_registered_owner == 'Yes' || !v.owner_name">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.is_registered_owner == 'No' || v.owner_name">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3" *ngIf="v.postcode">
                            <div class="col-md-4 text-white"><label>Overnight Postcode(s):</label></div>
                            <div class="col-md-8"><input type="text" [value]="overnightPostcodes(v)" class="form-control form-control-sm" readonly></div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-accordion>

    <!-- ══ Trailers ══ -->
    <mat-accordion multi *ngIf="quoteData.trailers && quoteData.trailers.length > 0">
        <div class="form_sections" *ngFor="let v of quoteData.trailers; let i = index">
            <mat-expansion-panel [expanded]="i == 0">
                <mat-expansion-panel-header>
                    <mat-panel-title><h4><u>Trailer {{ i + 1 }}</u></h4></mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-md-10">
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>VIN:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.vin" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Trailer Type:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.trailer_type" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Make:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.make" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Model:</label></div>
                            <div class="col-md-8"><input type="text" [value]="v.model" class="form-control form-control-sm" readonly></div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Value:</label></div>
                            <div class="col-md-8">
                                <div class="input-group">
                                    <div class="input-group-prepend"><span class="input-group-text dark-green-bg text-white">&pound;</span></div>
                                    <input type="text" [value]="v.value" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-md-4 text-white"><label>Registered Owner:</label></div>
                            <div class="col-md-8">
                                <mat-radio-group class="row" disabled>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="Yes" [checked]="v.is_registered_owner == 'Yes' || !v.owner_name">Yes</mat-radio-button></div></div>
                                    <div class="col-md-4"><div class="quote_radio w-90"><mat-radio-button value="No" [checked]="v.is_registered_owner == 'No' || v.owner_name">No</mat-radio-button></div></div>
                                </mat-radio-group>
                            </div>
                        </div>
                        <div class="row mb-3" *ngIf="v.postcode">
                            <div class="col-md-4 text-white"><label>Overnight Postcode(s):</label></div>
                            <div class="col-md-8"><input type="text" [value]="overnightPostcodes(v)" class="form-control form-control-sm" readonly></div>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </mat-accordion>

</div>
